import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { addDelegate } from "../../../redux/slices/delegates/delegatesThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddDelegatesPage = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const dispatch = useDispatch();
  const onFinish = (values) => {
    const formattedValues = {
      email: values.email,
      firstname: values.firstName,
      lastname: values.lastName,
      phoneNumber: values.phone,
      address: values.adresse,
      password: values.password,
    };
    dispatch(addDelegate(formattedValues)).then(
      (res) => {
        if (res.meta.requestStatus==="fulfilled") {
          history.push("/délégués");
        }
      }
    );
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter un delegué"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Réinitialiser
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/utilisateurs")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddDelegatesPage;